export default "__VITE_ASSET__DId2x4Ia__"